// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bn-bar {
  display: none;
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 200;
  background: var(--bg-secondary);
  border-top: 1px solid var(--border);
  box-shadow: var(--shadow-panel);
  padding-bottom: env(safe-area-inset-bottom, 0px);
}

@media (max-width: 768px) {
  .bn-bar {
    display: flex;
    align-items: stretch;
    justify-content: space-between;
  }
}

.bn-item {
  flex: 1 1;
  min-height: 56px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 2px;
  background: none;
  border: none;
  color: var(--text-secondary);
  font-size: 0.65rem;
  font-weight: 600;
  position: relative;
  cursor: pointer;
  transition: color var(--dur-fast) var(--ease-in-out);
}

.bn-item::before {
  content: '';
  position: absolute;
  top: 5px;
  left: 50%;
  width: 34px;
  height: 28px;
  border-radius: var(--radius-pill);
  background: var(--color-secondary-soft);
  opacity: 0;
  transform: translateX(-50%) scale(0.75);
  transition: opacity var(--dur-fast) var(--ease-in-out), transform var(--dur-fast) var(--ease-spring);
  pointer-events: none;
}

.bn-item > svg,
.bn-item > .bn-icon-wrap,
.bn-item > .bn-label {
  position: relative;
  z-index: 1;
}

.bn-item.active {
  color: var(--accent);
}

.bn-item.active::before {
  opacity: 1;
  transform: translateX(-50%) scale(1);
}

.bn-item:active::before {
  opacity: 1;
  transform: translateX(-50%) scale(1.12);
}

.bn-item:focus-visible {
  outline: 2px solid var(--accent);
  outline-offset: -2px;
}

/* 12px, not the 10.4px inherited from .bn-item. These five words are the
   app's primary navigation on a phone; Material specifies 12sp for bottom
   nav labels and iOS tab bars are ~13px, so the inherited 0.65rem sat under
   both. Set here rather than on .bn-item so the badge and icon are
   untouched. */
.bn-label {
  line-height: 1;
  font-size: 0.75rem;
}

.bn-icon-wrap {
  position: relative;
  display: flex;
}

.bn-badge {
  position: absolute;
  top: -4px;
  right: -8px;
  /* Blue, not orange. The cart badge used --danger (which resolves to the
     brand orange) while the wishlist badge beside it used blue, so two
     counters doing the same job -- "there are N things in here" -- sat next
     to each other in different colours and read as different kinds of
     message. Orange is reserved for primary commercial actions and
     promotions; a count is information, which is blue's role. One
     treatment now covers both, and .bn-badge-count no longer has to
     override it. */
  background: var(--color-secondary);
  color: var(--color-text-on-secondary);
  border-radius: 50%;
  /* 9.3px was the smallest text anywhere in the app, and it's a number the
     customer is meant to read at a glance (items in cart). The bubble grows
     with it -- 18px still clears the icon it sits on. */
  min-width: 18px;
  height: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.75rem;
  font-weight: 700;
  line-height: 1;
  padding: 0 3px;
}

/* Kept as a hook for the wishlist counter, which now inherits the shared
   blue treatment above rather than restating it. */

/* Mobile category bottom-sheet */
.bn-cat-sheet-overlay {
  position: fixed;
  inset: 0;
  background: rgba(1, 13, 33,0.4);
  z-index: 210;
  display: flex;
  align-items: flex-end;
  overscroll-behavior: contain;
}

.bn-cat-sheet {
  background: var(--bg-secondary);
  border-radius: var(--radius-lg) var(--radius-lg) 0 0;
  width: 100%;
  max-height: 70vh;
  overflow-y: auto;
  padding: var(--space-2) var(--space-2) calc(var(--space-2) + env(safe-area-inset-bottom, 0px));
  animation: bnSheetUp var(--dur-base) var(--ease-out-expo);
  overscroll-behavior-y: contain;
}

@keyframes bnSheetUp {
  from { transform: translateY(100%); }
  to   { transform: translateY(0); }
}

.bn-cat-sheet-draghandle {
  /* Drag-to-dismiss zone -- kept separate from the scrollable item list below
     so a downward swipe here closes the sheet, while swiping the list itself
     still just scrolls it. touch-action:none stops the browser's own
     scroll/refresh gesture from fighting the JS-driven drag. */
  touch-action: none;
  cursor: grab;
  margin: calc(var(--space-2) * -1) calc(var(--space-2) * -1) 0;
  padding: var(--space-2) var(--space-2) 0;
}

.bn-cat-sheet-handle {
  width: 36px;
  height: 4px;
  border-radius: 2px;
  background: var(--border);
  margin: 0 auto var(--space-2);
}

.bn-cat-sheet-hdr-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0 0 var(--space-2);
}

.bn-cat-sheet-title {
  font-size: 1rem;
  font-weight: 700;
  color: var(--text-primary);
  margin: 0;
}

.bn-cat-sheet-close {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  border-radius: 50%;
  border: none;
  background: var(--bg-tertiary);
  color: var(--text-secondary);
  cursor: pointer;
  flex-shrink: 0;
}
.bn-cat-sheet-close:hover,
.bn-cat-sheet-close:focus-visible {
  background: var(--border);
  color: var(--text-primary);
}

.bn-cat-sheet-item {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  min-height: 44px;
  padding: 10px 8px;
  background: none;
  border: none;
  border-radius: var(--radius-sm);
  font-size: 0.95rem;
  color: var(--text-primary);
  text-align: left;
  cursor: pointer;
  /* These are <a href> elements now, not <button>s, so that the mobile
     category sheet gives crawlers real links to every category page.
     Cancels the UA link underline so the sheet looks unchanged. */
  text-decoration: none;
}

.bn-cat-sheet-item.active {
  color: var(--accent);
  font-weight: 700;
  background: rgba(59, 130, 246,0.06);
}

.bn-cat-sheet-item:focus-visible {
  outline: 2px solid var(--accent);
  outline-offset: 2px;
}

/* Mobile account sheet */
.mas-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(1, 13, 33,0.4);
  z-index: 210;
  display: flex;
  align-items: flex-end;
  overscroll-behavior: contain;
}

.mas-sheet {
  background: var(--bg-secondary);
  border-radius: var(--radius-lg) var(--radius-lg) 0 0;
  width: 100%;
  max-height: 80vh;
  overflow-y: auto;
  padding: var(--space-2) var(--space-2) calc(var(--space-2) + env(safe-area-inset-bottom, 0px));
  animation: bnSheetUp var(--dur-base) var(--ease-out-expo);
  overscroll-behavior-y: contain;
}

.mas-header {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: var(--space-1) var(--space-1) var(--space-2);
  border-bottom: 1px solid var(--border);
  margin-bottom: var(--space-1);
}

.mas-avatar {
  width: 46px;
  height: 46px;
  border-radius: 50%;
  background: linear-gradient(135deg, var(--accent), var(--accent-secondary));
  color: var(--color-brand-white);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.2rem;
  font-weight: 800;
  flex-shrink: 0;
}

.mas-avatar-img {
  object-fit: cover;
}

.mas-header-text { flex: 1 1; min-width: 0; }

.mas-hello {
  font-size: 1.05rem;
  font-weight: 800;
  color: var(--text-primary);
}

.mas-sub {
  font-size: 0.8rem;
  color: var(--text-secondary);
}

.mas-close {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  border: none;
  background: var(--bg-tertiary);
  color: var(--text-secondary);
  font-size: 1.2rem;
  line-height: 1;
  cursor: pointer;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.mas-list {
  display: flex;
  flex-direction: column;
}

.mas-item {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  min-height: 52px;
  padding: 8px 4px;
  background: none;
  border: none;
  text-align: left;
  cursor: pointer;
  font-size: 0.92rem;
  font-weight: 600;
  color: var(--text-primary);
}

.mas-item:focus-visible { outline: 2px solid var(--accent); outline-offset: 2px; }

/* Nested under the item above it (e.g. Track Order under My Orders) --
   same icon size/column and same text color as every other row so it reads
   as a normal, equally-actionable item; only the height/size are slightly
   reduced to show it's a secondary action. */
.mas-item-sub {
  min-height: 46px;
  font-size: 0.86rem;
  font-weight: 500;
}

.mas-item-icon {
  width: 34px;
  height: 34px;
  border-radius: var(--radius-sm);
  color: var(--color-brand-white);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.mas-item-label { flex: 1 1; min-width: 0; }

.mas-item-badge {
  background: var(--color-secondary);
  color: var(--color-text-on-secondary);
  border-radius: 999px;
  min-width: 18px;
  height: 18px;
  font-size: 0.68rem;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 5px;
}

.mas-chevron { color: var(--text-muted); display: flex; flex-shrink: 0; }

.mas-divider {
  height: 1px;
  background: var(--border);
  margin: var(--space-1) 0;
}

.mas-logout {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  min-height: 48px;
  padding: 8px 4px;
  background: none;
  border: none;
  text-align: left;
  cursor: pointer;
  font-size: 0.95rem;
  font-weight: 700;
  color: var(--danger);
}

.mas-logout:focus-visible { outline: 2px solid var(--danger); outline-offset: 2px; }

/* Installed-app finishing: remove browser tap flashes, keep primary controls
   comfortably above the gesture area, and make press feedback immediate.
 *
 * Both selectors throughout, because none of this is actually about Capacitor:
 * a PWA opened from the home screen is the same thumb on the same gesture bar,
 * with the same browser tap-flash to suppress. .is-native-app is the packaged
 * app (set in index.js); html.m-installed covers it and the installed PWA. */
.is-native-app .bn-bar,
html.m-installed .bn-bar {
  min-height: calc(60px + env(safe-area-inset-bottom, 0px));
  box-shadow: 0 -6px 24px rgba(1, 13, 33, 0.10);
}

.is-native-app .bn-item,
.is-native-app .bn-cat-sheet-item,
.is-native-app .mas-item,
.is-native-app .mas-logout,
.is-native-app .bn-cat-sheet-close,
.is-native-app .mas-close,
html.m-installed .bn-item,
html.m-installed .bn-cat-sheet-item,
html.m-installed .mas-item,
html.m-installed .mas-logout,
html.m-installed .bn-cat-sheet-close,
html.m-installed .mas-close {
  -webkit-tap-highlight-color: transparent;
  touch-action: manipulation;
}

.is-native-app .bn-item,
html.m-installed .bn-item {
  min-height: 60px;
}

.is-native-app .bn-cat-sheet,
.is-native-app .mas-sheet,
html.m-installed .bn-cat-sheet,
html.m-installed .mas-sheet {
  max-height: min(82dvh, 720px);
}

.is-native-app .bn-cat-sheet-item:active,
.is-native-app .mas-item:active,
.is-native-app .mas-logout:active,
html.m-installed .bn-cat-sheet-item:active,
html.m-installed .mas-item:active,
html.m-installed .mas-logout:active {
  background: var(--color-surface-hover);
}

@media (prefers-reduced-motion: reduce) {
  .bn-cat-sheet,
  .mas-sheet { animation: none; }
  .bn-item::before { transition: none; }
}
`, "",{"version":3,"sources":["webpack://./src/BottomNav.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,eAAe;EACf,OAAO;EACP,QAAQ;EACR,SAAS;EACT,YAAY;EACZ,+BAA+B;EAC/B,mCAAmC;EACnC,+BAA+B;EAC/B,gDAAgD;AAClD;;AAEA;EACE;IACE,aAAa;IACb,oBAAoB;IACpB,8BAA8B;EAChC;AACF;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,YAAY;EACZ,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,oDAAoD;AACtD;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,uCAAuC;EACvC,UAAU;EACV,uCAAuC;EACvC,oGAAoG;EACpG,oBAAoB;AACtB;;AAEA;;;EAGE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,UAAU;EACV,oCAAoC;AACtC;;AAEA;EACE,UAAU;EACV,uCAAuC;AACzC;;AAEA;EACE,gCAAgC;EAChC,oBAAoB;AACtB;;AAEA;;;;eAIe;AACf;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX;;;;;;;mBAOiB;EACjB,kCAAkC;EAClC,qCAAqC;EACrC,kBAAkB;EAClB;;wDAEsD;EACtD,eAAe;EACf,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;;AAEA;mDACmD;;AAEnD,iCAAiC;AACjC;EACE,eAAe;EACf,QAAQ;EACR,+BAA+B;EAC/B,YAAY;EACZ,aAAa;EACb,qBAAqB;EACrB,4BAA4B;AAC9B;;AAEA;EACE,+BAA+B;EAC/B,oDAAoD;EACpD,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,8FAA8F;EAC9F,yDAAyD;EACzD,8BAA8B;AAChC;;AAEA;EACE,OAAO,2BAA2B,EAAE;EACpC,OAAO,wBAAwB,EAAE;AACnC;;AAEA;EACE;;;+DAG6D;EAC7D,kBAAkB;EAClB,YAAY;EACZ,6DAA6D;EAC7D,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,8BAA8B;EAC9B,4BAA4B;EAC5B,eAAe;EACf,cAAc;AAChB;AACA;;EAEE,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,+BAA+B;EAC/B,kBAAkB;EAClB,0BAA0B;EAC1B,gBAAgB;EAChB,eAAe;EACf;;kEAEgE;EAChE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA;EACE,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA,yBAAyB;AACzB;EACE,eAAe;EACf,QAAQ;EACR,+BAA+B;EAC/B,YAAY;EACZ,aAAa;EACb,qBAAqB;EACrB,4BAA4B;AAC9B;;AAEA;EACE,+BAA+B;EAC/B,oDAAoD;EACpD,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,8FAA8F;EAC9F,yDAAyD;EACzD,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,qDAAqD;EACrD,sCAAsC;EACtC,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,2EAA2E;EAC3E,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,mBAAmB,SAAO,EAAE,YAAY,EAAE;;AAE1C;EACE,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,8BAA8B;EAC9B,4BAA4B;EAC5B,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA,0BAA0B,gCAAgC,EAAE,mBAAmB,EAAE;;AAEjF;;;6CAG6C;AAC7C;EACE,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA,kBAAkB,SAAO,EAAE,YAAY,EAAE;;AAEzC;EACE,kCAAkC;EAClC,qCAAqC;EACrC,oBAAoB;EACpB,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA,eAAe,wBAAwB,EAAE,aAAa,EAAE,cAAc,EAAE;;AAExE;EACE,WAAW;EACX,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA,4BAA4B,gCAAgC,EAAE,mBAAmB,EAAE;;AAEnF;;;;;;6EAM6E;AAC7E;;EAEE,yDAAyD;EACzD,6CAA6C;AAC/C;;AAEA;;;;;;;;;;;;EAYE,wCAAwC;EACxC,0BAA0B;AAC5B;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;;;;EAIE,6BAA6B;AAC/B;;AAEA;;;;;;EAME,sCAAsC;AACxC;;AAEA;EACE;eACa,eAAe,EAAE;EAC9B,mBAAmB,gBAAgB,EAAE;AACvC","sourcesContent":[".bn-bar {\n  display: none;\n  position: fixed;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 200;\n  background: var(--bg-secondary);\n  border-top: 1px solid var(--border);\n  box-shadow: var(--shadow-panel);\n  padding-bottom: env(safe-area-inset-bottom, 0px);\n}\n\n@media (max-width: 768px) {\n  .bn-bar {\n    display: flex;\n    align-items: stretch;\n    justify-content: space-between;\n  }\n}\n\n.bn-item {\n  flex: 1;\n  min-height: 56px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 2px;\n  background: none;\n  border: none;\n  color: var(--text-secondary);\n  font-size: 0.65rem;\n  font-weight: 600;\n  position: relative;\n  cursor: pointer;\n  transition: color var(--dur-fast) var(--ease-in-out);\n}\n\n.bn-item::before {\n  content: '';\n  position: absolute;\n  top: 5px;\n  left: 50%;\n  width: 34px;\n  height: 28px;\n  border-radius: var(--radius-pill);\n  background: var(--color-secondary-soft);\n  opacity: 0;\n  transform: translateX(-50%) scale(0.75);\n  transition: opacity var(--dur-fast) var(--ease-in-out), transform var(--dur-fast) var(--ease-spring);\n  pointer-events: none;\n}\n\n.bn-item > svg,\n.bn-item > .bn-icon-wrap,\n.bn-item > .bn-label {\n  position: relative;\n  z-index: 1;\n}\n\n.bn-item.active {\n  color: var(--accent);\n}\n\n.bn-item.active::before {\n  opacity: 1;\n  transform: translateX(-50%) scale(1);\n}\n\n.bn-item:active::before {\n  opacity: 1;\n  transform: translateX(-50%) scale(1.12);\n}\n\n.bn-item:focus-visible {\n  outline: 2px solid var(--accent);\n  outline-offset: -2px;\n}\n\n/* 12px, not the 10.4px inherited from .bn-item. These five words are the\n   app's primary navigation on a phone; Material specifies 12sp for bottom\n   nav labels and iOS tab bars are ~13px, so the inherited 0.65rem sat under\n   both. Set here rather than on .bn-item so the badge and icon are\n   untouched. */\n.bn-label {\n  line-height: 1;\n  font-size: 0.75rem;\n}\n\n.bn-icon-wrap {\n  position: relative;\n  display: flex;\n}\n\n.bn-badge {\n  position: absolute;\n  top: -4px;\n  right: -8px;\n  /* Blue, not orange. The cart badge used --danger (which resolves to the\n     brand orange) while the wishlist badge beside it used blue, so two\n     counters doing the same job -- \"there are N things in here\" -- sat next\n     to each other in different colours and read as different kinds of\n     message. Orange is reserved for primary commercial actions and\n     promotions; a count is information, which is blue's role. One\n     treatment now covers both, and .bn-badge-count no longer has to\n     override it. */\n  background: var(--color-secondary);\n  color: var(--color-text-on-secondary);\n  border-radius: 50%;\n  /* 9.3px was the smallest text anywhere in the app, and it's a number the\n     customer is meant to read at a glance (items in cart). The bubble grows\n     with it -- 18px still clears the icon it sits on. */\n  min-width: 18px;\n  height: 18px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 0.75rem;\n  font-weight: 700;\n  line-height: 1;\n  padding: 0 3px;\n}\n\n/* Kept as a hook for the wishlist counter, which now inherits the shared\n   blue treatment above rather than restating it. */\n\n/* Mobile category bottom-sheet */\n.bn-cat-sheet-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(1, 13, 33,0.4);\n  z-index: 210;\n  display: flex;\n  align-items: flex-end;\n  overscroll-behavior: contain;\n}\n\n.bn-cat-sheet {\n  background: var(--bg-secondary);\n  border-radius: var(--radius-lg) var(--radius-lg) 0 0;\n  width: 100%;\n  max-height: 70vh;\n  overflow-y: auto;\n  padding: var(--space-2) var(--space-2) calc(var(--space-2) + env(safe-area-inset-bottom, 0px));\n  animation: bnSheetUp var(--dur-base) var(--ease-out-expo);\n  overscroll-behavior-y: contain;\n}\n\n@keyframes bnSheetUp {\n  from { transform: translateY(100%); }\n  to   { transform: translateY(0); }\n}\n\n.bn-cat-sheet-draghandle {\n  /* Drag-to-dismiss zone -- kept separate from the scrollable item list below\n     so a downward swipe here closes the sheet, while swiping the list itself\n     still just scrolls it. touch-action:none stops the browser's own\n     scroll/refresh gesture from fighting the JS-driven drag. */\n  touch-action: none;\n  cursor: grab;\n  margin: calc(var(--space-2) * -1) calc(var(--space-2) * -1) 0;\n  padding: var(--space-2) var(--space-2) 0;\n}\n\n.bn-cat-sheet-handle {\n  width: 36px;\n  height: 4px;\n  border-radius: 2px;\n  background: var(--border);\n  margin: 0 auto var(--space-2);\n}\n\n.bn-cat-sheet-hdr-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin: 0 0 var(--space-2);\n}\n\n.bn-cat-sheet-title {\n  font-size: 1rem;\n  font-weight: 700;\n  color: var(--text-primary);\n  margin: 0;\n}\n\n.bn-cat-sheet-close {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 44px;\n  height: 44px;\n  border-radius: 50%;\n  border: none;\n  background: var(--bg-tertiary);\n  color: var(--text-secondary);\n  cursor: pointer;\n  flex-shrink: 0;\n}\n.bn-cat-sheet-close:hover,\n.bn-cat-sheet-close:focus-visible {\n  background: var(--border);\n  color: var(--text-primary);\n}\n\n.bn-cat-sheet-item {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  width: 100%;\n  min-height: 44px;\n  padding: 10px 8px;\n  background: none;\n  border: none;\n  border-radius: var(--radius-sm);\n  font-size: 0.95rem;\n  color: var(--text-primary);\n  text-align: left;\n  cursor: pointer;\n  /* These are <a href> elements now, not <button>s, so that the mobile\n     category sheet gives crawlers real links to every category page.\n     Cancels the UA link underline so the sheet looks unchanged. */\n  text-decoration: none;\n}\n\n.bn-cat-sheet-item.active {\n  color: var(--accent);\n  font-weight: 700;\n  background: rgba(59, 130, 246,0.06);\n}\n\n.bn-cat-sheet-item:focus-visible {\n  outline: 2px solid var(--accent);\n  outline-offset: 2px;\n}\n\n/* Mobile account sheet */\n.mas-backdrop {\n  position: fixed;\n  inset: 0;\n  background: rgba(1, 13, 33,0.4);\n  z-index: 210;\n  display: flex;\n  align-items: flex-end;\n  overscroll-behavior: contain;\n}\n\n.mas-sheet {\n  background: var(--bg-secondary);\n  border-radius: var(--radius-lg) var(--radius-lg) 0 0;\n  width: 100%;\n  max-height: 80vh;\n  overflow-y: auto;\n  padding: var(--space-2) var(--space-2) calc(var(--space-2) + env(safe-area-inset-bottom, 0px));\n  animation: bnSheetUp var(--dur-base) var(--ease-out-expo);\n  overscroll-behavior-y: contain;\n}\n\n.mas-header {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: var(--space-1) var(--space-1) var(--space-2);\n  border-bottom: 1px solid var(--border);\n  margin-bottom: var(--space-1);\n}\n\n.mas-avatar {\n  width: 46px;\n  height: 46px;\n  border-radius: 50%;\n  background: linear-gradient(135deg, var(--accent), var(--accent-secondary));\n  color: var(--color-brand-white);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1.2rem;\n  font-weight: 800;\n  flex-shrink: 0;\n}\n\n.mas-avatar-img {\n  object-fit: cover;\n}\n\n.mas-header-text { flex: 1; min-width: 0; }\n\n.mas-hello {\n  font-size: 1.05rem;\n  font-weight: 800;\n  color: var(--text-primary);\n}\n\n.mas-sub {\n  font-size: 0.8rem;\n  color: var(--text-secondary);\n}\n\n.mas-close {\n  width: 44px;\n  height: 44px;\n  border-radius: 50%;\n  border: none;\n  background: var(--bg-tertiary);\n  color: var(--text-secondary);\n  font-size: 1.2rem;\n  line-height: 1;\n  cursor: pointer;\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.mas-list {\n  display: flex;\n  flex-direction: column;\n}\n\n.mas-item {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  width: 100%;\n  min-height: 52px;\n  padding: 8px 4px;\n  background: none;\n  border: none;\n  text-align: left;\n  cursor: pointer;\n  font-size: 0.92rem;\n  font-weight: 600;\n  color: var(--text-primary);\n}\n\n.mas-item:focus-visible { outline: 2px solid var(--accent); outline-offset: 2px; }\n\n/* Nested under the item above it (e.g. Track Order under My Orders) --\n   same icon size/column and same text color as every other row so it reads\n   as a normal, equally-actionable item; only the height/size are slightly\n   reduced to show it's a secondary action. */\n.mas-item-sub {\n  min-height: 46px;\n  font-size: 0.86rem;\n  font-weight: 500;\n}\n\n.mas-item-icon {\n  width: 34px;\n  height: 34px;\n  border-radius: var(--radius-sm);\n  color: var(--color-brand-white);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.mas-item-label { flex: 1; min-width: 0; }\n\n.mas-item-badge {\n  background: var(--color-secondary);\n  color: var(--color-text-on-secondary);\n  border-radius: 999px;\n  min-width: 18px;\n  height: 18px;\n  font-size: 0.68rem;\n  font-weight: 700;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0 5px;\n}\n\n.mas-chevron { color: var(--text-muted); display: flex; flex-shrink: 0; }\n\n.mas-divider {\n  height: 1px;\n  background: var(--border);\n  margin: var(--space-1) 0;\n}\n\n.mas-logout {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  width: 100%;\n  min-height: 48px;\n  padding: 8px 4px;\n  background: none;\n  border: none;\n  text-align: left;\n  cursor: pointer;\n  font-size: 0.95rem;\n  font-weight: 700;\n  color: var(--danger);\n}\n\n.mas-logout:focus-visible { outline: 2px solid var(--danger); outline-offset: 2px; }\n\n/* Installed-app finishing: remove browser tap flashes, keep primary controls\n   comfortably above the gesture area, and make press feedback immediate.\n *\n * Both selectors throughout, because none of this is actually about Capacitor:\n * a PWA opened from the home screen is the same thumb on the same gesture bar,\n * with the same browser tap-flash to suppress. .is-native-app is the packaged\n * app (set in index.js); html.m-installed covers it and the installed PWA. */\n.is-native-app .bn-bar,\nhtml.m-installed .bn-bar {\n  min-height: calc(60px + env(safe-area-inset-bottom, 0px));\n  box-shadow: 0 -6px 24px rgba(1, 13, 33, 0.10);\n}\n\n.is-native-app .bn-item,\n.is-native-app .bn-cat-sheet-item,\n.is-native-app .mas-item,\n.is-native-app .mas-logout,\n.is-native-app .bn-cat-sheet-close,\n.is-native-app .mas-close,\nhtml.m-installed .bn-item,\nhtml.m-installed .bn-cat-sheet-item,\nhtml.m-installed .mas-item,\nhtml.m-installed .mas-logout,\nhtml.m-installed .bn-cat-sheet-close,\nhtml.m-installed .mas-close {\n  -webkit-tap-highlight-color: transparent;\n  touch-action: manipulation;\n}\n\n.is-native-app .bn-item,\nhtml.m-installed .bn-item {\n  min-height: 60px;\n}\n\n.is-native-app .bn-cat-sheet,\n.is-native-app .mas-sheet,\nhtml.m-installed .bn-cat-sheet,\nhtml.m-installed .mas-sheet {\n  max-height: min(82dvh, 720px);\n}\n\n.is-native-app .bn-cat-sheet-item:active,\n.is-native-app .mas-item:active,\n.is-native-app .mas-logout:active,\nhtml.m-installed .bn-cat-sheet-item:active,\nhtml.m-installed .mas-item:active,\nhtml.m-installed .mas-logout:active {\n  background: var(--color-surface-hover);\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .bn-cat-sheet,\n  .mas-sheet { animation: none; }\n  .bn-item::before { transition: none; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
